import React, { Component } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';
import '../css/validations.css';
import moment from 'moment';

class DocumentStockModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    closeModal = () => {
        $("#documentStockModal").modal("hide");
    }

    render() {
        const { data, openLocation, formatNumber, isMarketingDoc = false } = this.props;
        return (
            <div
                className="modal fade bd-example-modal-xl modal-open scroll"
                id="documentStockModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-xl modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title"> Contabilización de Stock por Documento </h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                                <span className="text-white" aria-hidden="true"> &times; </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table table-scroll response mb-0">
                                                <div id="dataContenido"
                                                    className="w-100"
                                                    style={{ maxHeight: 450 }}>
                                                    <table
                                                        id="dataTableDocuments"
                                                        className="display"
                                                        style={{ width: '100%', marginBottom: 40 }}>
                                                        <thead className="table-header-yellow">
                                                            <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                                <th> Fecha </th>
                                                                <th> Documento </th>
                                                                <th> Fila del documento </th>
                                                                <th> Almacén </th>
                                                                <th> Primera ubicación de destino </th>
                                                                <th> Articulo </th>
                                                                <th> Cantidad </th>
                                                                <th> Precio tras el descuento </th>
                                                                <th> Info. detallada </th>
                                                                <th> Clase de articulo </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!!data && Array.isArray(data) ? data?.filter(row => !isMarketingDoc || (Number(row.AbsEntry || 0) > 0))?.map((element, index) => {
                                                                return (
                                                                    <tr key={index} className="align-middle text-center">
                                                                        <td> {moment(new Date(element.DocDate)).format("DD/MM/YYYY")} </td>
                                                                        <td> {(element.DocNum)} </td>
                                                                        <td> {Number(element.LineNum) + 1} </td>
                                                                        <td> {element.WhsCode} </td>
                                                                        <td className="text-left">
                                                                            <button
                                                                                type="button"
                                                                                style={{
                                                                                    backgroundColor: 'transparent',
                                                                                    color: '#EABF28',
                                                                                    paddingTop: 2,
                                                                                    paddingBottom: 2,
                                                                                    border: "1px solid #ced4da"
                                                                                }}
                                                                                className="btn btn-outline-secondary mr-3"
                                                                                onClick={() => openLocation(element.AbsEntry)}>
                                                                                <i className="fas fa-map-marker-alt" aria-hidden="true" />
                                                                            </button>
                                                                            {element.BinCode}
                                                                        </td>
                                                                        <td> {element.ItemCode} </td>
                                                                        <td> {element.Quantity * (Number(element.DocAction) === 2 ? -1 : 1)} </td>
                                                                        <td> {`${element.Currency || ''} ${formatNumber.new(Number(element.PriceBefDi))}`} </td>
                                                                        <td> {element.Comment} </td>
                                                                        <td> {Number(element.ItemClass) === 2 ? 'Articulo' : 'Servicio'} </td>
                                                                    </tr>
                                                                );
                                                            })
                                                                : <></>}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn botonCerrar text-white"
                                onClick={this.closeModal}>
                                Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

export default connect(
    mapStateToProps
)(DocumentStockModal);